import getCookie from '../getCookie';
import { formatCookie } from '../cookieAttributes';
import { navigateAway } from '../backNavigationGuard';

export const getRedirectUrl = ({ state, redirectUrl, status = '' }) => {
  document.cookie = formatCookie('generateDivarState', state);

  return navigateAway(
    `https://oauth.divar.ir/oauth2/auth?response_type=code&client_id=UID&redirect_uri=${redirectUrl}&scope=USER_PHONE%20SUBMIT_USER_PAYMENT%20${
      status === 'profile' ? 'USER_ADDON_CREATE' : `POST_ADDON_CREATE.${getCookie('post_token')}`
    }&state=${state}`,
  );
};
